import { render } from "./AppGraphs.vue?vue&type=template&id=70f42424"
import script from "./AppGraphs.vue?vue&type=script&lang=js"
export * from "./AppGraphs.vue?vue&type=script&lang=js"

import "./AppGraphs.vue?vue&type=style&index=0&id=70f42424&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__